/* eslint-disable react-refresh/only-export-components */

import { CuriosityValue } from '@procureai/curiosity-ui-mui';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

import { CuriosityLookupProps, LookupErrorMessageProps } from './TransCuriosityLookup.types';

export const getCuriosityValues = ({ ids, ns, delimiter, valueGetter }: CuriosityLookupProps) => {
  if (isEmpty(ids)) {
    return [];
  }

  const idArray = ([] as string[]).concat(ids);
  const lastIndex = idArray.length - 1;
  return idArray.map((id, index) => {
    return (
      <CuriosityValue key={id} ns={ns} i18nKey={id} valueGetter={valueGetter}>
        {(val) => {
          if (index === lastIndex) {
            return <>{val}</>;
          }
          return (
            <>
              {val}
              {delimiter}
            </>
          );
        }}
      </CuriosityValue>
    );
  });
};

export const LookupErrorMessage = ({ variant }: LookupErrorMessageProps) => {
  const { t } = useTranslation(I18nNamespace.businessLog);
  return <span>{t('error.resolving', { context: variant })}</span>;
};
